module.exports = __webpack_public_path__ + "media/landing_work/home/images/arrow-purple-501de637adf9464fb8004a7c94860d34.svg";